export const messages = {
  en: {
    tenant: {
      search: {
        title: 'Search Condition',
        tenantId: 'tenantId',
        name: 'name',
        address: 'address',
        tel: 'tel',
        createTime: 'createTime',
        placeholder: 'Please enter tenant name'
      },
      list: {
        title: 'tenant List'
      },
      dialog: {
        addTitle: 'Add tenant',
        editTitle: 'Edit tenant',
        delTitle: 'Delete tenant',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        tenantId: 'tenantId',
        name: 'name',
        address: 'address',
        tel: 'tel',
        createTime: 'createTime',
      },
      table: {
        tenantId: 'tenantId',
        name: 'name',
        address: 'address',
        tel: 'tel',
        createTime: 'createTime',
        resetPassword: 'resetPassword'
      },
      validate: {
        tenantId: 'Please enter tenantId',
        name: 'Please enter name',
        address: 'Please enter address',
        tel: 'Please enter tel',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add tenant success'
      },
      edit: {
        success: 'Edit tenant success'
      },
      delete: {
        success: 'Delete tenant success',
        confirm: 'Are you sure to delete this tenant?'
      },
      fetchError: 'Failed to fetch tenant list'
    }
  },
  zh: {
    tenant: {
      search: {
        title: '查询条件',
        tenantId: '租户ID',
        name: '名称',
        address: '地址',
        tel: '电话',
        createTime: '创建时间',
        placeholder: '请输入tenant名称'
      },
      list: {
        title: '租户列表'
      },
      dialog: {
        addTitle: '添加租户',
        editTitle: '编辑租户',
        delTitle: '删除租户',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        tenantId: '租户ID',
        name: '名称',
        address: '地址',
        tel: '电话',
        createTime: '创建时间',
      },
      table: {
        tenantId: '租户ID',
        name: '名称',
        address: '地址',
        tel: '电话',
        createTime: '创建时间',
        resetPassword: '重置密码'
      },
      validate: {
        tenantId: '请输入租户ID',
        name: '请输入名称',
        address: '请输入地址',
        tel: '请输入电话',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加tenant成功'
      },
      edit: {
        success: '编辑tenant成功'
      },
      delete: {
        success: '删除tenant成功',
        confirm: '确认删除该tenant吗？'
      },
      fetchError: '获取tenant列表失败'
    }
  }
}